import { cn } from "@/lib/utils";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";

interface QuizFeedbackProps {
  isSubmitted: boolean;
  isCorrect: boolean | null;
  positiveFeedback?: string;
  negativeFeedback?: string;
  neutralFeedback?: string;
  className?: string;
}

const QuizFeedback = ({
  isSubmitted,
  isCorrect,
  positiveFeedback,
  negativeFeedback,
  neutralFeedback,
  className,
}: QuizFeedbackProps) => {
  if (!isSubmitted || isCorrect === null) {
    return null;
  }

  const getFeedbackStyles = () => {
    if (neutralFeedback) {
      return {
        container: "bg-warning-light border border-warning-border",
        text: "text-warning-foreground",
      };
    }

    if (isCorrect === true && positiveFeedback) {
      return {
        container: "bg-success-light border border-success-border",
        text: "text-success-foreground",
      };
    }

    if (isCorrect === false && negativeFeedback) {
      return {
        container: "bg-error-light border border-error-border",
        text: "text-error-foreground",
      };
    }

    return {
      container: "bg-muted border border-border",
      text: "text-foreground",
    };
  };

  const getFeedbackText = () => {
    if (isCorrect === true && positiveFeedback) {
      return positiveFeedback;
    } else if (neutralFeedback) {
      return neutralFeedback;
    } else if (isCorrect === false && negativeFeedback) {
      return negativeFeedback;
    } else {
      return "";
    }
  };

  const styles = getFeedbackStyles();

  return (
    <div className={cn("p-4 rounded-lg mb-6", styles.container, className)}>
      <p className="mb-2 font-bold uppercase tracking-wide text-foreground">
        Feedback
      </p>
      {/* prose brings its own body color — inherit so the tint above wins */}
      <div
        className={cn(
          "prose max-w-full prose-p:my-0 prose-p:text-inherit prose-strong:text-inherit prose-li:text-inherit",
          styles.text
        )}
      >
        <CourseMarkdown>{getFeedbackText()}</CourseMarkdown>
      </div>
    </div>
  );
};

export default QuizFeedback;
